export type HomeService = {
  title: string
  description: string
  image: string
  cta: string
  href: string
}

export const homeServices: HomeService[] = [
  {
    title: 'Marketing',
    description: 'Local SEO, paid ads, social and email campaigns that bring in real customers — not just clicks.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e21159cd-c2be-4d64-9921-f48b3205da96.jpg',
    cta: 'See Our Marketing Services',
    href: '#/marketing',
  },
  {
    title: 'Website Design',
    description: 'Custom, mobile-friendly websites and landing pages built to turn visitors into leads.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c558dfdd-56db-4529-b4c4-68b23617f99c.jpg',
    cta: 'See Our Website Design',
    href: '#/design/websites',
  },
  {
    title: 'CRM & Automation',
    description: '1Dash.Pro catches every lead, follows up for you and keeps customers coming back.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/bdfdd1b1-7af1-4035-aa29-febd673d898d.jpg',
    cta: 'See Our Marketing CRM',
    href: '#/crm',
  },
  {
    title: 'AI',
    description: 'AI that answers your phone 24/7, chats with website visitors and books appointments for you.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c198a9b9-c9d4-4fc8-aa0c-76aab58b1595.jpg',
    cta: 'See Our AI Tools',
    href: '#/marketing/ai-phone',
  },
]
